<template>
    <div>
        <div class="simple-row">
            <div class="left">
                <button class="swb-btn swb-btn-small swb-btn-small" v-if="!showDetail" @click="addAppliedShop()">新增门店</button>
            </div>
        </div>
        <el-table :data="selectComList" border style="width: 100%" height="565">
            <el-table-column type="index" label="行号" align="center" width="50"></el-table-column>
            <el-table-column prop="bizUnitName" label="业务单元" width="180" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column prop="bizAreaName" label="经营区域" width="180" align="left" show-overflow-tooltip></el-table-column>
            <el-table-column prop="bizFormName" label="经营业态" align="left"></el-table-column>
            <el-table-column prop="mgmtSmlAreaName" label="管理区域" align="left"></el-table-column>
            <el-table-column prop="quantity" label="服务费用" align="left">
                <template slot-scope="rows">
                    <el-input type="number" :min="0" v-model.number="rows.row.price" :disabled="showDetail"></el-input>
                </template>
            </el-table-column>
            <el-table-column label="操作" align="left" width="80" v-if="!showDetail">
                <template slot-scope="rows">
                    <a class="swb-btn swb-btn-link" @click="removeComInfo($index)">移除</a>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import { Utils } from '../../app.base'
import { MsgBox } from '../../app.vues'
import { openRetailerShopListForSelectDlg } from '../retailer/selectDlg';

export default {
    name: 'swb-contract-servc-org-price-list',
    desc: '合同服务门店价格',
    props: ['servcPrice', 'orgPriceList', 'contractAppliedShopList', 'showDetail', 'filterMerchantId', 'merchantId'],
    data: function () {
        return {
            selectComList: [],
        }
    },
    created: function () {
        if(this.orgPriceList.length >= 0) {
            this.selectComList = Utils.merge([], this.orgPriceList);
        }
    },
    methods: {
        addAppliedShop: function () {
            let self = this;
            let contractAppliedShopList = this.contractAppliedShopList || [];
            if(contractAppliedShopList.length <= 0) {
                MsgBox.warning("请先选择适用机构");
                return false;
            }
            let selectComList = this.selectComList || [];
            let queryFilter = {
                checkBox: true,
                filter: {
                    ids: contractAppliedShopList.pluck("shopId"),
                    filterMerchantId: self.filterMerchantId,
                    merchantId: self.merchantId
                },
                disableIds: selectComList.pluck("bizUnitId"),
                title: '零售机构 - 选择'
            };
            openRetailerShopListForSelectDlg(queryFilter, function (comList, theDlg) {
                theDlg.close();
                if(comList.length > 0) {
                    for(let i = 0; i < comList.length; i++) {
                        let comInfo = comList[i];
                        selectComList.push({
                            bizUnitId: comInfo.id,
                            bizUnitName: comInfo.name,
                            shopFlag: comInfo.shopFlag,
                            bizAreaId: comInfo.bizAreaId,
                            bizAreaName: comInfo.bizAreaName,
                            bizFormId: comInfo.bizFormId,
                            bizFormName: comInfo.bizFormName,
                            mgmtSmlAreaId: comInfo.mgmtSmlAreaId,
                            mgmtSmlAreaName: comInfo.mgmtSmlAreaName,
                            price: self.servcPrice || 0.00,
                        });
                    }
                }
                self.selectComList = Utils.merge([], selectComList);
            });
        },
        removeComInfo: function (index) {
            let selectComList = this.selectComList || [];
            selectComList.splice(index, 1);
            this.selectComList = Utils.merge([], selectComList);
        },
        getDlgResult: function () {
            return {
                type: 'info',
                data: this.selectComList || []
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/compo/contract/ContractServcOrgPriceList.vue